import { KeyboardEvent, MouseEvent, ChangeEvent } from 'react';

/**
 * Label Position
 */

export enum LabelPositionEnum {
  Top = 'top',
  In = 'in',
}
export type TLabelPosition = keyof typeof LabelPositionEnum;

/**
 * Input Type
 */

export enum InputTypeEnum {
  Input = 'input',
  Textarea = 'textarea',
}
export type TInputType = keyof typeof InputTypeEnum;

/**
 * Input Text Type
 */

export type TInputTextType = 'text' | 'password' | 'email';

/**
 * Input Dropdown Event Type
 */

export type TInputDropdownEventType = 'Search' | 'ImmediateSearch' | 'Select' | 'Tab';

/**
 * Box Type
 */

export enum TBoxTypeEnum {
  Checkbox = 'checkbox',
  Radio = 'radio',
}
export type TBoxType = keyof typeof TBoxTypeEnum;

/**
 * Input Key Event
 */

export type TKeyEvent = KeyboardEvent<HTMLInputElement>;
export type TClickEvent = MouseEvent<HTMLInputElement>;
export type TChangeEvent = ChangeEvent<HTMLInputElement>;

/**
 * Form Types
 */

export type TFormField = Record<string, unknown>;
